module.exports = __webpack_public_path__ + "resources/bootstrap/fonts/glyphicons-halflings-regular.eot";


//////////////////
// WEBPACK FOOTER
// ./src/resources/bootstrap/fonts/glyphicons-halflings-regular.eot
// module id = 333
// module chunks = 0